export default (value, config = {}) => {
  const date = new Date(value);

  return date.toLocaleDateString('pt-br', { ...config });
};
